import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'entities';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'Entities';
const items = [{
  link: "".concat(base(), "entities"),
  label: 'Entities'
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Maintenance",
    items: [{
      link: "".concat(base(), "countries"),
      label: 'Countries'
    }, {
      link: "".concat(base(), "currencies"),
      label: 'Currency'
    }, {
      link: "".concat(base(), "entity_groups"),
      label: 'Entity Groups'
    }, {
      link: "".concat(base(), "languages"),
      label: 'Language'
    }, {
      link: "".concat(base(), "payment_methods"),
      label: 'Payment Methods'
    }, {
      link: "".concat(base('contracts'), "market_zones"),
      label: 'Market Zones'
    }, {
      link: "".concat(base('contracts'), "merchandisers"),
      label: 'Merchandisers'
    }, {
      link: "".concat(base(), "entity_note_categories"),
      label: 'Note Categories'
    }, {
      link: "".concat(base('contracts'), "source_locations"),
      label: 'Source Locations'
    }, {
      link: "".concat(base('contracts'), "transportation_modes"),
      label: 'Transportation Modes'
    }]
  })
}];
const Entities = () => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: items
});
export default Entities;